/** Normalize `{ error }` from pro-api / user-service (string or Zod-shaped object). */
export function messageFromApiErrorPayload(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const record = data as Record<string, unknown>;
  const err = record.error;

  if (typeof err === 'string' && err.trim()) {
    return err.trim();
  }

  if (Array.isArray(err)) {
    const first = err[0];
    if (first && typeof first === 'object' && 'message' in first) {
      const msg = (first as { message?: unknown }).message;
      if (typeof msg === 'string' && msg.trim()) return msg.trim();
    }
  }

  if (err && typeof err === 'object') {
    const issues = (err as { issues?: Array<{ message?: string }> }).issues;
    if (Array.isArray(issues) && issues[0]?.message) {
      return issues[0].message;
    }
    if ('message' in err) {
      const msg = (err as { message?: unknown }).message;
      if (typeof msg === 'string' && msg.trim()) return msg.trim();
    }
  }

  return null;
}
